'use client';

import { __awaiter, __generator, __assign } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import { Anchor } from '../Typography/components/Variant.js';
import { Container } from './styled.js';
import { getAdrTurbo } from '../services/adr-turbo/index.js';
import { ELanguage } from '../Utils/constants.js';
import Skeleton from '../Skeleton/index.js';

var ADR1_SETTING = 'ADR1_SETTING';
var ADR2_SETTING = 'ADR2_SETTING';
function AdrTurboBanner(_a) {
    var _this = this;
    var baseMsUrl = _a.baseMsUrl, type = _a.type, lang = _a.lang;
    var _b = useState(null), adrTubos = _b[0], setAdrTubos = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var shuffleArray = function (array) {
        var _a;
        if (!Array.isArray(array))
            return [];
        var currentIndex = array.length;
        var randomIndex;
        // While there remain elements to shuffle.
        while (currentIndex > 0) {
            // Pick a remaining element.
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;
            _a = [array[randomIndex], array[currentIndex]], array[currentIndex] = _a[0], array[randomIndex] = _a[1];
        }
        return array;
    };
    var getBanner = function () { return __awaiter(_this, void 0, void 0, function () {
        var adrTurboResponse, banners, bannerIds, adrKeySetting, adrSetting, newIndex, indexBanner, adrTurbo, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getAdrTurbo(baseMsUrl, type, lang)];
                case 1:
                    adrTurboResponse = _c.sent();
                    if ((adrTurboResponse === null || adrTurboResponse === void 0 ? void 0 : adrTurboResponse.data) && adrTurboResponse.data.length > 0) {
                        banners = adrTurboResponse.data;
                        bannerIds = banners.map(function (item) { return item.id; });
                        adrKeySetting = type === 1 ? ADR1_SETTING : ADR2_SETTING;
                        adrSetting = JSON.parse(localStorage.getItem(adrKeySetting)) || {
                            bannerIds: [],
                            sufferIndex: [],
                            index: 0
                        };
                        if (JSON.stringify(bannerIds) === JSON.stringify(adrSetting.bannerIds)) {
                            newIndex = (adrSetting.index + 1) % adrSetting.bannerIds.length;
                            adrSetting.index = newIndex;
                            localStorage.setItem(adrKeySetting, JSON.stringify(adrSetting));
                        }
                        else {
                            adrSetting.bannerIds = bannerIds;
                            adrSetting.index = 0;
                            adrSetting.sufferIndex = shuffleArray(Array.from(Array(banners.length).keys()));
                            localStorage.setItem(adrKeySetting, JSON.stringify(adrSetting));
                        }
                        indexBanner = adrSetting.sufferIndex[adrSetting.index];
                        adrTurbo = __assign(__assign({}, adrTurboResponse.data[indexBanner].attributes), { altImg: lang === ELanguage.EN
                                ? "Latest ".concat((_a = adrTurboResponse.data[indexBanner].attributes) === null || _a === void 0 ? void 0 : _a.companyName, " employment/hiring with high salary & attractive benefits")
                                : "".concat((_b = adrTurboResponse.data[indexBanner].attributes) === null || _b === void 0 ? void 0 : _b.companyName, " tuy\u1EC3n d\u1EE5ng - T\u00ECm vi\u1EC7c m\u1EDBi nh\u1EA5t, l\u01B0\u01A1ng th\u01B0\u1EDFng h\u1EA5p d\u1EABn. ") });
                        setAdrTubos(adrTurbo);
                        setLoading(false);
                    }
                    setLoading(false);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _c.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (type) {
            getBanner();
        }
    }, [type]);
    var renderSkeleton = function () {
        return loading ? (React__default.createElement(Container, null,
            React__default.createElement(Skeleton, { height: 350 }))) : (React__default.createElement(React__default.Fragment, null));
    };
    return adrTubos ? (React__default.createElement(Container, null,
        React__default.createElement(Anchor, { href: adrTubos.companyURL, target: '_blank', rel: 'noreferrer', style: { width: '100%', height: '100%', display: 'inline-block' } },
            React__default.createElement("img", { loading: 'lazy', src: adrTubos === null || adrTubos === void 0 ? void 0 : adrTubos.image, alt: adrTubos.altImg })))) : (renderSkeleton());
}

export { AdrTurboBanner as default };
//# sourceMappingURL=index.js.map
